import styled from 'styled-components/macro';
import { colorCoreGray200, colorCoreGray500, colorCoreWhite1000 } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
export const LabelStyled = styled.div `
  padding: ${INDENT.xxxxs} ${INDENT.xxxs};
  background-color: ${colorCoreGray200};
  // todo: md: move to constants?
  box-shadow: inset 0px 5px 8px rgba(219, 219, 219, 0.25);

  &:not(:first-child) {
    border-top: 1px solid ${colorCoreGray500};
  }

  ${ADAPTIVE.maxWidth.tablet} {
    padding: ${INDENT.xxs};
    background-color: ${colorCoreWhite1000};
    box-shadow: none;
  }
`;
export const AccordionContentStyled = styled.div `
  ${ADAPTIVE.maxWidth.tablet} {
    padding: 14px;
    border-top: 1px solid ${colorCoreGray500};
  }
`;
